import { trackEvent } from "../../common/analytics";

export const sendAnalytics = ({ payload, context }) => {
    const analyticsDataList = [...context, payload];
    const analyticsEvent = analyticsDataList.reduce(
        (mergedAnalyticsEvent, currentAnalyicsEvent) => {
            return { ...mergedAnalyticsEvent, ...currentAnalyicsEvent };
        },
        {}
    );
    trackEvent(analyticsEvent.eventName, analyticsEvent);
}